import React from 'react';
import { QuestRoute } from '../../api/QuestRoutes';
import { useParams } from 'react-router-dom';
import { generateId, shortHandDate } from '../../utility/functions';
import Table from '../../table/Table';

const ClaimedDeals = ({ children, ...props }) => {
    const { guid } = useParams();

    const tableConfig = {
        endpoint: QuestRoute.user.claimedDeals(guid),
        isReport: true,
        headers: [
            {
                label: 'Name',
                propKey: 'name',
                options: true
            }, {
                label: 'Claimed',
                propKey: 'claimed',
                type: 'date'
            }, {
                label: 'Expires',
                propKey: 'expires',
                type: 'date'
            }, {
                label: 'Last Used',
                propKey: 'lastUsed',
                type: 'date'
            }, {
                label: 'Code',
                propKey: 'code',
            }, {
                label: 'Voided',
                propKey: 'isVoided',
                // options: true
            },
        ],
        // quickSort: [],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>{e.name}</td>
                <td>{shortHandDate(e.claimed)}</td>
                <td>{shortHandDate(e.expires)}</td>
                <td>{shortHandDate(e.lastUsed)}</td>
                <td>{e.code}</td>
                <td>{e.isVoided ? 'Yes' : 'No'}</td>
            </tr>
        )
    }

    return <Table config={tableConfig} />
}

export default ClaimedDeals;
